'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var reactTextMask = require('../../../node_modules/react-text-mask/dist/reactTextMask.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var EINMaskedInput = function EINMaskedInput(_ref) {
  var inputRef = _ref.inputRef,
      restProps = objectWithoutProperties(_ref, ["inputRef"]);

  var einMask = [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  return React__default["default"].createElement(reactTextMask, _extends["default"]({}, restProps, {
    ref: function ref(_ref2) {
      return inputRef(_ref2 ? _ref2.inputElement : null);
    },
    mask: einMask,
    placeholderChar: "\u2000",
    showMask: false
  }));
};

module.exports = EINMaskedInput;
